import React, {useEffect, useState} from 'react'

export const FormTextArea = ({
  label,
  required,
  onChange,
  placeholder,
  name,
  value: defaultValue,
  register,
}) => {
  const [value, setValue] = useState(defaultValue)

  useEffect(() => {
    setValue(defaultValue)
  }, [defaultValue])

  return (
    <div className='input-container'>
      {label && (
        <p>
          {label}
          {required && <span>*</span>}
        </p>
      )}
      <textarea
        required={required}
        name={name}
        placeholder={placeholder}
        value={value}
        rows={4}
        onChange={(e) => {
          setValue(e.target.value)
          onChange?.(e.target.value)
        }}
        {...register?.(name)}
      />
    </div>
  )
}
